import React from 'react';
import BaseGrid from '@material-ui/core/Grid';

const Grid = (props) => <BaseGrid {...props} />;

export default Grid;
